import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import TradingPausedBanner from '../common/TradingPausedBanner';
import { useTradingStatus } from '../../context/TradingStatusContext';

const Layout: React.FC = () => {
  const { tradingEnabled } = useTradingStatus();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
      <Header />
      <TradingPausedBanner visible={!tradingEnabled} />
      <main className="p-3 sm:p-4 lg:p-5">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;